(function() {
    'use strict';
    angular.module('ngModalDragabble', []).directive('modalDragabble', function() {
        return {
            restrict: 'A',
            scope: {},
            link: function(scope, element) {
                $('#' + element[0].id + '.options-modal > .modal-container').draggable({
                    containment: '#' + element[0].id + '.options-modal',
                    scroll: false,
                    start: function() {
                    },
                    drag: function() {
                    },
                    stop: function() {
                    }
                });
            }
        };
    });
}());



// WEBPACK FOOTER //
// ./app/directives/modal-dragable.js